/* eslint-disable no-case-declarations */
import produce from 'immer';
import { GET_EMAIL_TEMPLATE_TOKENS_SUCCESS, GET_EMAIL_TEMPLATES_SUMMARIES_SUCCESS, SET_TEMPLATE_ID } from './emailTemplateTypes';

const initialState = {
  isLoaded: false,
  areTokenLoaded: false,
  emailTemplates: [],
  tokens: []
};

export default produce((draft = initialState, action) => {
  switch (action.type) {
    case GET_EMAIL_TEMPLATES_SUMMARIES_SUCCESS:
      if (action.response === undefined) {
        break;
      }
      draft.emailTemplates = action.response;
      draft.isLoaded = true;
      break;

    case GET_EMAIL_TEMPLATE_TOKENS_SUCCESS:
      if (action.response === undefined) {
        break;
      }
      draft.tokens = action.response;
      draft.areTokenLoaded = true;
      break;

    case SET_TEMPLATE_ID:
      draft.currentTemplateId = action.response;
      break;

    default:
      break;
  }

  return draft;
}, initialState);
